import React, { useState, useEffect, useCallback } from 'react';
import { 
    Box, Button, Checkbox, Container, FormControl, FormControlLabel, FormGroup,
    Grid, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography, Chip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { pl } from 'date-fns/locale';
import Services from '../services/Services';

// Modal için gerekli Material-UI importları
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// CloseIcon importu (çarpı işareti için)
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import * as XLSX from 'xlsx'; // Excel işlemleri için
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// Tag renkleri için bir harita
const tagColors = {
    'H.B': { bgcolor: 'rgba(255, 244, 237, 1)', color: 'rgba(255, 156, 102, 1)', borderColor: 'rgba(255, 214, 174, 1)' },
    'Trendyol': { bgcolor: 'rgba(255, 244, 237, 1)', color: 'rgba(107, 114, 128, 1)', borderColor: 'rgba(255, 214, 174, 1)' },
    'Aras Kargo': { bgcolor: 'rgba(237, 244, 255, 1)', color: 'rgba(49, 101, 204, 1)', borderColor: 'rgba(174, 202, 255, 1)' },
    'Sürat Kargo': { bgcolor: 'rgba(237, 255, 244, 1)', color: 'rgba(49, 204, 101, 1)', borderColor: 'rgba(174, 255, 214, 1)' },
    'Kargoist': { bgcolor: 'rgba(243, 244, 246, 1)', color: 'rgba(107, 114, 128, 1)', borderColor: 'rgba(222, 222, 222, 1)' },
    'Hepsijet': { bgcolor: 'rgba(255, 237, 237, 1)', color: 'rgba(107, 114, 128, 1)', borderColor: 'rgba(251, 219, 215, 1)' },
};

// Belirtilen tag için renkleri döndüren fonksiyon
const getTagColorStyles = (tag) => {
    return tagColors[tag] || {
        bgcolor: '#f0f0f0',
        color: '#333',
        borderColor: '#ccc',
    };
};

const NotificationManagement = () => {
    const [currentStep, setCurrentStep] = useState(1); // 1: Mesaj ekranı, 2: Nokta Seçim, 3: Kişi Seçim
    const [notificationMessage, setNotificationMessage] = useState('');
    const [selectedPoints, setSelectedPoints] = useState({}); // { noktaId: true/false }
    const [selectedPeople, setSelectedPeople] = useState({}); // { kisiId: true/false }
    const [totalSelectedPeopleCount, setTotalSelectedPeopleCount] = useState(0);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isExcelDataLoaded, setIsExcelDataLoaded] = useState(false);
    const [showOnlySelected, setShowOnlySelected] = useState(false);
    const [points, setPoints] = useState([]); // Artık sadece GetPoints ile dolacak
    const [users, setUsers] = useState([]);
    const [token, setToken] = useState(null);

    // Filtreleme state'leri
    const [filterType, setFilterType] = useState('all');
    const [filterProvince, setFilterProvince] = useState('all');
    const [filterDistrict, setFilterDistrict] = useState('all');
    const [activeTags, setActiveTags] = useState([]);
    const [filterUserName, setFilterUserName] = useState('');
    const [filterPointName, setFilterPointName] = useState('');
    const [filterBranchCode, setFilterBranchCode] = useState('');
    const fileInputRef = React.useRef(null);

    // Pagination state'leri
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);

    // GetPoints ile noktaları çek
    useEffect(() => {
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        const token = parsedUser?.token;
        if (!token) return;
        setIsLoading(true);
        Services.GetPoints(token)
            .then((res) => {
                if (res.data.status && Array.isArray(res.data.result)) {
                    setPoints(res.data.result);

                    console.log("Res : ",res)
                } else {
                    setPoints([]);
                }
            })
            .catch(() => setPoints([]))
            .finally(() => setIsLoading(false));
        const users = Services.GetUsers(token)
            .then((res) => {
                if (res.data.status && Array.isArray(res.data.result)) {
                    setUsers(res.data.result);

                    console.log("Res : ",res)
                } else {
                    setUsers([]);
                }
            })
            .catch(() => setUsers([]))
            .finally(() => setIsLoading(false));
        console.log("USERS  :",users)
    }, []);

    // Toplam seçili kişi sayısını güncelleme efekti
    useEffect(() => {
        const count = Object.values(selectedPeople).filter(Boolean).length;
        setTotalSelectedPeopleCount(count);
    }, [selectedPeople]);

    // İl seçildiğinde ilçe filtresi sıfırlansın
    useEffect(() => {
        setFilterDistrict('all');
    }, [filterProvince]);

    // Tag seçimi yönetimi
    const handleToggleTag = (tag) => {
        setActiveTags((prevTags) => {
            if (prevTags.includes(tag)) {
                return prevTags.filter((t) => t !== tag);
            } else {
                return [...prevTags, tag];
            }
        });
    };

    // Filtreleri sıfırlama
    // Tüm filtreleri ve seçimleri temizleyen kapsamlı bir fonksiyon
    const handleClearAllFilters = useCallback(() => {
        setFilterType('all');
        setFilterProvince('all');
        setFilterDistrict('all');
        setActiveTags([]);
        setFilterUserName('');
        setFilterPointName('');
        setFilterBranchCode('');
        setShowOnlySelected(false); // Sadece seçilenleri göster filtresini de sıfırla
    }, []);

    // Tüm seçimleri temizleyen fonksiyon
    const handleClearAllSelections = useCallback(() => {
        setSelectedPoints({});
        setSelectedPeople({});
        handleClearAllFilters(); // Seçimler temizlerken filtreleri de sıfırla (bu zaten showOnlySelected'ı sıfırlar)
        setIsExcelDataLoaded(false); // Seçimler temizlendiği için Excel verisi yüklenmedi olarak işaretle
    }, [handleClearAllFilters]);


    // "Nokta Ekle" butonu tıklandığında
    const handleAddPointClick = () => {
        setCurrentStep(2); // Nokta Seçim ekranına geç
        handleClearAllFilters(); // Filtreleri sıfırla
    };

    // "Kişi Ekle" butonu tıklandığında
    const handleAddPersonClick = () => {
        setCurrentStep(3); // Kişi Seçim ekranına geç
        handleClearAllFilters(); // Filtreleri sıfırla
    };

    // Seçim ekranından geri dönme
    const handleBackToMessageScreen = () => {
        setCurrentStep(1);
    };

    // Nokta seçimini yönetme
    const handlePointCheckboxChange = (pointId, isChecked) => {
        setSelectedPoints(prevSelectedPoints => {
            const newSelectedPoints = { ...prevSelectedPoints, [pointId]: isChecked };

            // Eğer nokta seçildiyse, ilgili kişileri de selectedPeople'a ekle/çıkar
            const point = points.find(p => p.id === pointId);
            if (point && point.users) {
                setSelectedPeople(prevSelectedPeople => {
                    const newSelectedPeople = { ...prevSelectedPeople };
                    point.users.forEach(person => {
                        newSelectedPeople[person.id] = isChecked;
                    });
                    return newSelectedPeople;
                });
            }
            return newSelectedPoints;
        });
    };

    // Kişi seçimini yönetme
    const handlePersonCheckboxChange = (personId, isChecked) => {
        setSelectedPeople(prevSelectedPeople => {
            const newSelectedPeople = {
                ...prevSelectedPeople,
                [personId]: isChecked
            };

            // Kişinin bağlı olduğu noktayı bul
            let relatedPointId = null;
            for (const point of points) {
                if (Array.isArray(point.users) && point.users.some(user => user.id === personId)) {
                    relatedPointId = point.id;
                    break;
                }
            }

            if (relatedPointId) {
                setSelectedPoints(prevSelectedPoints => {
                    const newSelectedPoints = { ...prevSelectedPoints };
                    if (isChecked) {
                        // Kişi seçildiyse, bağlı olduğu noktayı seçili yap
                        newSelectedPoints[relatedPointId] = true;
                    } else {
                        // Kişi seçimi kaldırıldıysa, o noktadaki başka seçili kişi var mı kontrol et
                        const relatedPoint = points.find(p => p.id === relatedPointId);
                        let anyOtherSelected = false;
                        if (relatedPoint && Array.isArray(relatedPoint.users)) {
                            anyOtherSelected = relatedPoint.users.some(user => user.id !== personId && newSelectedPeople[user.id]);
                        }
                        if (!anyOtherSelected) {
                            newSelectedPoints[relatedPointId] = false;
                        }
                    }
                    return newSelectedPoints;
                });
            }

            return newSelectedPeople;
        });
    };

    const handleSaveSelection = () => {
        // Seçilen noktaları ve kişileri kontrol et
        const selectedPointsCount = Object.keys(selectedPoints).filter(id => selectedPoints[id]).length;
        const selectedPeopleCount = Object.keys(selectedPeople).filter(id => selectedPeople[id]).length;

        if (selectedPointsCount === 0 && selectedPeopleCount === 0) {
            toast.error("Lütfen en az bir nokta veya kişi seçin!");
            return;
        }

        toast.success("Seçimler başarıyla kaydedildi!");
        setCurrentStep(1); // Mesaj ekranına geri dön

        console.log("SelectedPoints", selectedPoints)
        console.log("selectedPeople", selectedPeople)
    };

    // Onay modalını açma fonksiyonu
    const handleOpenConfirmModal = () => {
        console.log("Selected people : ",selectedPeople);
        console.log("Selected Points : ", selectedPoints)
        const selectedUserIds = Object.keys(selectedPeople).filter(personId => selectedPeople[personId] === true);
        console.log("selectedUserIds : ", selectedUserIds)
        if (!notificationMessage.trim()) {
            toast.error("Bildirim mesajı boş olamaz!");
            return;
        }
        if (totalSelectedPeopleCount === 0) {
            toast.error("Lütfen bildirim göndermek için en az bir kişi/nokta seçin!");
            return;
        }
        setIsConfirmModalOpen(true);
    };

    // Onay modalını kapatma fonksiyonu
    const handleCloseConfirmModal = () => {
        setIsConfirmModalOpen(false);
    };

    // Asıl bildirim gönderme fonksiyonu
    const handleSendNotification = async () => {
        try {
            setIsLoading(true);
            
            // Sadece selectedPeople'da true olan kullanıcıları topla
            const selectedUserIds = Object.keys(selectedPeople).filter(personId => selectedPeople[personId] === true);

            if (selectedUserIds.length === 0) {
                toast.error("Lütfen en az bir kullanıcı seçin!");
                return;
            }

            console.log("Selected User IDs", selectedUserIds);
            console.log("Notification Message", notificationMessage);

            // API'ye gönder
            Services.SendPushNotification(
                selectedUserIds,
                "Bildirim",
                notificationMessage
            )
            .then((res) => {
                if (res.data.status) {
                    toast.success("Bildirim başarıyla gönderildi!");
                    // State'leri sıfırla
                    setNotificationMessage('');
                    setSelectedPoints({});
                    setSelectedPeople({});
                    setIsConfirmModalOpen(false);
                } else {
                    toast.error(res.data.message || "Bildirim gönderilirken bir hata oluştu.");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error sending notification:', err);
                toast.error("Bildirim gönderilirken bir hata oluştu.");
                setIsLoading(false);
            });

        } catch (error) {
            console.error('Error:', error);
            toast.error("Bir hata oluştu.");
            setIsLoading(false);
        }
    };

    const handleExcelFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        setIsLoading(true);

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (jsonData.length === 0) {
                    toast.warn("Excel dosyası boş veya geçersiz.");
                    setIsLoading(false);
                    return;
                }

                const headers = jsonData[0].map(header => String(header).trim().toLowerCase());
                const branchCodeColumnIndex = headers.indexOf('şubekodu'); // Sütun başlığını küçük harfe duyarsız kontrol et

                if (branchCodeColumnIndex === -1) {
                    toast.error("Excel dosyasında 'ŞubeKodu' başlıklı sütun bulunamadı.");
                    setIsLoading(false);
                    return;
                }

                const branchCodesFromExcel = new Set();
                for (let i = 1; i < jsonData.length; i++) {
                    const row = jsonData[i];
                    if (row && row[branchCodeColumnIndex]) {
                        branchCodesFromExcel.add(String(row[branchCodeColumnIndex]).trim());
                    }
                }

                if (branchCodesFromExcel.size === 0) {
                    toast.info("Excel dosyasında işlenecek şube kodu bulunamadı.");
                    setIsLoading(false);
                    return;
                }

                let newSelectedPoints = { ...selectedPoints };
                let newSelectedPeopleData = { ...selectedPeople }; // selectedPeople'ı doğrudan değiştirmek yerine kopya oluştur
                let foundCount = 0;
                const notFoundCodes = new Set(branchCodesFromExcel);

                points.forEach(point => {
                    if (branchCodesFromExcel.has(String(point.branchCode).trim())) {
                        newSelectedPoints[point.id] = true;
                        foundCount++;
                        notFoundCodes.delete(String(point.branchCode).trim());
                        if (point.users) {
                            point.users.forEach(person => {
                                newSelectedPeopleData[person.id] = true;
                            });
                        }
                    }
                });

                console.log("Points : ",points)

                setSelectedPoints(newSelectedPoints);
                setSelectedPeople(newSelectedPeopleData); // Güncellenmiş kopya ile state'i ayarla

                setIsExcelDataLoaded(true); // Excel verisi başarıyla yüklendi
                if (foundCount > 0) toast.success(`${foundCount} şube kodu ile eşleşen noktalar seçildi.`);
                if (notFoundCodes.size > 0) toast.warn(`${notFoundCodes.size} şube kodu bulunamadı: ${Array.from(notFoundCodes).join(', ')}`);
                if (foundCount === 0 && notFoundCodes.size === branchCodesFromExcel.size) toast.info("Excel'deki şube kodlarıyla eşleşen nokta bulunamadı.");

            } catch (error) {
                console.error("Excel dosyası okunurken hata oluştu:", error);
                toast.error("Excel dosyası işlenirken bir hata oluştu.");
            } finally {
                setIsLoading(false);
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        };
        reader.onerror = () => {
            toast.error("Dosya okunurken bir hata oluştu.");
            setIsLoading(false);
        };
        reader.readAsArrayBuffer(file);
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Sadece Seçilenleri Göster aktif olduğunda, Excel'den import edilenler seçili değilse seçili yap
    useEffect(() => {
        if (showOnlySelected && isExcelDataLoaded) {
            // Excel'den import edilen noktalar ve kişiler zaten seçili olarak işaretlenmiş olmalı
            // Ancak kullanıcı elle seçimleri kaldırdıysa tekrar seçili yap
            let updatedSelectedPoints = { ...selectedPoints };
            let updatedSelectedPeople = { ...selectedPeople };
            let changed = false;
            points.forEach(point => {
                if (selectedPoints[point.id]) {
                    // Nokta seçiliyse, ilgili kişileri de seçili yap
                    if (point.users) {
                        point.users.forEach(person => {
                            if (!updatedSelectedPeople[person.id]) {
                                updatedSelectedPeople[person.id] = true;
                                changed = true;
                            }
                        });
                    }
                }
            });
            if (changed) {
                setSelectedPeople(updatedSelectedPeople);
            }
        }
    }, [showOnlySelected, isExcelDataLoaded, points, selectedPoints]);

    // En üste çık fonksiyonu
    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Step 1: Bildirim Mesajı Oluşturma Ekranı
    const renderNotificationMessageScreen = () => (
        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', minHeight: '500px', display: 'flex', flexDirection: 'column' }}>
            {/* Seçili Noktaların İsimleri */}
            <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center" sx={{ mb: 3 }}>
                {/* Seçili Noktalar Alanı */}
                
                <Stack direction="column" spacing={1} alignItems="flex-start" sx={{ flexWrap: 'wrap', flex: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Seçili Noktalar:</Typography>
                    <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ flexWrap: 'wrap', flex: 1, gap: 0.5 }}>
                        {Object.keys(selectedPoints).filter(id => selectedPoints[id]).length > 0 &&
                            points.filter(p => selectedPoints[p.id]).map(point => (
                                <Typography
                                    key={point.id}
                                    label={point.title || point.name || '-'}
                                    sx={{ color: '#da3831', fontWeight: 'bold', marginLeft: '0 !important' }}
                                >
                                    {point.title || point.name || '-'} -
                                </Typography>
                            ))
                        }
                    </Stack>
                </Stack>
                {/* Ekle Butonları */}
                <Button variant="contained" sx={{ bgcolor: '#da3831', '&:hover': { bgcolor: '#c02f2a' } }} onClick={handleAddPointClick}>
                    <Box component="span" sx={{ fontSize: '1.2rem', mr: 0.5 }}>+</Box> Nokta Ekle {Object.keys(selectedPoints).filter(id => selectedPoints[id]).length > 0 && `(${Object.keys(selectedPoints).filter(id => selectedPoints[id]).length})`}
                </Button>
                <Button variant="contained" sx={{ bgcolor: '#da3831', '&:hover': { bgcolor: '#c02f2a' } }} onClick={handleAddPersonClick}>
                    <Box component="span" sx={{ fontSize: '1.2rem', mr: 0.5 }}>+</Box> Kişi Ekle {totalSelectedPeopleCount > 0 && `(${totalSelectedPeopleCount})`}
                </Button>
            </Stack>

            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Bildirim Mesajı
            </Typography>
            <TextField
                multiline
                rows={8}
                placeholder="Bildirim mesajı içeriği..."
                variant="outlined"
                fullWidth
                value={notificationMessage}
                onChange={(e) => setNotificationMessage(e.target.value)}
                sx={{ mb: 3 }}
            />

            <Button
                variant="contained"
                sx={{ bgcolor: '#da3831', '&:hover': { bgcolor: '#c02f2a' }, alignSelf: 'center', width: '100%', py: 2, }}
                onClick={handleOpenConfirmModal} // Buton şimdi modalı açacak
            >
                Bildirimi Gönder
            </Button>
        </Paper>
    );

    // Step 2 & 3: Ortak Seçim Ekranı
    const renderSelectionScreen = (isPointSelection) => {
        const pageTitle = isPointSelection ? "Nokta Ekle" : "Kişi Ekle";

        const availableTags = [
            'Trendyol', 'H.B', 'Aras Kargo', 'Sürat Kargo', 'Kargoist', 'Hepsijet'
        ];

        // --- İl ve ilçe dropdown'ları için points kullanılacak ---
        const provinces = [...new Set(points.map(p => p.city).filter(Boolean))].sort();
        const districts = filterProvince === 'all'
            ? []
            : [...new Set(points.filter(p => p.city === filterProvince).map(p => p.district).filter(Boolean))].sort();
        
        let dataToFilter = isPointSelection ? points : [];
        if (isPointSelection) {
            dataToFilter = dataToFilter
                .filter(p => filterProvince === 'all' || p.city === filterProvince)
                .filter(p => filterDistrict === 'all' || p.district === filterDistrict)
                .filter(p => filterPointName === '' || (p.title && p.title.toLocaleLowerCase('tr-TR').includes(filterPointName.toLocaleLowerCase('tr-TR'))))
                .filter(p => filterBranchCode === '' || (p.branchCode && String(p.branchCode).toLocaleLowerCase('tr-TR').includes(filterBranchCode.toLocaleLowerCase('tr-TR'))))
                .filter(p => filterType === 'all' || (p.isEsnaf === '1' ? 'Bireysel' : 'Kurumsal') === filterType)
                .filter(p => activeTags.length === 0 || activeTags.every(tag => {
                    const tags = [];
                    if (p.isTrendyol === '1') tags.push('Trendyol');
                    if (p.isHepsiburada === '1') tags.push('H.B');
                    if (p.isArasKargo === '1') tags.push('Aras Kargo');
                    if (p.isSuratkargo === '1') tags.push('Sürat Kargo');
                    if (p.kargoistID) tags.push('Kargoist');
                    if (p.hepsijetID) tags.push('Hepsijet');
                    return tags.includes(tag);
                }));
            // Sadece seçilenleri göster aktifse, sadece selectedPoints'da true olanları göster
            if (showOnlySelected) {
                dataToFilter = dataToFilter.filter(p => selectedPoints[p.id]);
            }
        }
        // Kişi ekle ekranı için filtreleme
        let peopleToFilter = [];
        if (!isPointSelection) {
            // Tüm noktalardaki tüm kullanıcıları tek diziye topla
            peopleToFilter = points.flatMap(point => (Array.isArray(point.users) ? point.users.map(user => ({
                ...user,
                pointId: point.id,
                pointTitle: point.title,
                branchCode: point.branchCode,
                city: point.city,
                district: point.district,
                type: point.isEsnaf === '1' ? 'Bireysel' : 'Kurumsal',
            })) : []));
            // Unique by id
            const seen = new Set();
            peopleToFilter = peopleToFilter.filter(person => {
                if (seen.has(person.id)) return false;
                seen.add(person.id);
                return true;
            });
            // Filtre uygula
            peopleToFilter = peopleToFilter
                .filter(person => filterUserName === '' || (person.name && person.name.toLocaleLowerCase('tr-TR').includes(filterUserName.toLocaleLowerCase('tr-TR'))))
                .filter(person => filterPointName === '' || (person.pointTitle && person.pointTitle.toLocaleLowerCase('tr-TR').includes(filterPointName.toLocaleLowerCase('tr-TR'))))
                .filter(person => filterBranchCode === '' || (person.branchCode && String(person.branchCode).toLocaleLowerCase('tr-TR').includes(filterBranchCode.toLocaleLowerCase('tr-TR'))))
                .filter(person => filterType === 'all' || person.type === filterType)
                .filter(person => filterProvince === 'all' || person.city === filterProvince)
                .filter(person => filterDistrict === 'all' || person.district === filterDistrict);
            // Sadece seçilenleri göster aktifse, sadece selectedPeople'da true olanları göster
            if (showOnlySelected) {
                peopleToFilter = peopleToFilter.filter(person => selectedPeople[person.id]);
            }
        }

        // İl ve ilçe filtrelerinin aktif/pasif durumunu belirle
        const areLocationFiltersDisabled = !isPointSelection || points.length === 0;
        const isDistrictDisabled = areLocationFiltersDisabled || filterProvince === 'all';

        // Ana checkbox durumu hesaplama
        const areAllFilteredItemsSelected = dataToFilter.length > 0 &&
            dataToFilter.every(item => isPointSelection ? !!selectedPoints[item.id] : !!selectedPeople[item.id]);

        // Ana checkbox'ın durumu değiştiğinde
        const handleSelectAllChange = (event) => {
            const isChecked = event.target.checked;
            if (isPointSelection) {
                const newSelectedPoints = { ...selectedPoints };
                const newSelectedPeople = { ...selectedPeople };

                dataToFilter.forEach(point => {
                    newSelectedPoints[point.id] = isChecked;
                    // Noktalar seçildiğinde/kaldırıldığında ilgili kişileri de güncelle
                    if (point.users) {
                        point.users.forEach(person => {
                            newSelectedPeople[person.id] = isChecked;
                        });
                    }
                });
                setSelectedPoints(newSelectedPoints);
                setSelectedPeople(newSelectedPeople);
            } else { // Kişi seçimi ekranı
                const newSelectedPeople = { ...selectedPeople };
                peopleToFilter.forEach(person => {
                    newSelectedPeople[person.id] = isChecked;
                });
                setSelectedPeople(newSelectedPeople);
            }
        };

        // Pagination için veriyi slice et
        const items = isPointSelection ? dataToFilter : peopleToFilter;
        const pagedItems = items.slice(page * pageSize, (page + 1) * pageSize);
        const totalPages = Math.ceil(items.length / pageSize);

        // Pagination componenti
        const PaginationControls = () => (
            <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 2, gap: 2 }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={page === 0}
                        onClick={() => setPage(page - 1)}
                    >
                        Önceki
                    </Button>
                    <Typography variant="body2">
                        Sayfa {page + 1} / {totalPages || 1}
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={page >= totalPages - 1}
                        onClick={() => setPage(page + 1)}
                    >
                        Sonraki
                    </Button>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body2">Göster:</Typography>
                    <Select
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value));
                            setPage(0);
                        }}
                        size="small"
                        sx={{ width: 80 }}
                    >
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={250}>250</MenuItem>
                    </Select>
                </Stack>
            </Stack>
        );

        return (
            <Paper sx={{ p: 3, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', minHeight: '500px', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #e0e0e0', pb: 2, mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                        {pageTitle}
                    </Typography>
                    <Button onClick={handleBackToMessageScreen} sx={{ minWidth: 'auto', p: 0.5, color: '#333' }}>
                        <ArrowBackIosIcon fontSize="small" />
                    </Button>
                </Stack>

                {/* Filtreleme Bölümü */}
                <Stack direction="column" spacing={2}>
                    <Typography variant="body1" sx={{ color: 'rgba(154, 158, 166, 1)' }}>Filtreleme</Typography>
                    <Grid
                        container
                        gap={2}
                        alignItems="center"
                        // lg (1200px) ve üzeri ekranlarda nowrap, altındaki ekranlarda wrap olacak
                        sx={{ flexWrap: { xs: 'wrap', lg: 'nowrap' } }}
                    >
                        {/* Kullanıcı Ara */}
                        <Grid item xs={12} md={12} lg={2.5}>
                            <TextField
                                fullWidth
                                label="Kullanıcı Ara..."
                                value={filterUserName}
                                onChange={(e) => setFilterUserName(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    sx: { height: '52px' }
                                }}
                                sx={{
                                    '.MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#ccc' },
                                        '&:hover fieldset': { borderColor: '#da3831' },
                                        '&.Mui-focused fieldset': { borderColor: '#da3831' },
                                    },
                                    '.MuiInputLabel-root': {
                                        '&.Mui-focused': { color: '#da3831' }
                                    },
                                }}
                            />
                        </Grid>
                        {/* Nokta Ara */}
                        <Grid item xs={12} md={12} lg={2.5}>
                            <TextField
                                fullWidth
                                label="Nokta Ara..."
                                value={filterPointName}
                                onChange={(e) => setFilterPointName(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    sx: { height: '52px' }
                                }}
                                sx={{
                                    '.MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#ccc' },
                                        '&:hover fieldset': { borderColor: '#da3831' },
                                        '&.Mui-focused fieldset': { borderColor: '#da3831' },
                                    },
                                    '.MuiInputLabel-root': {
                                        '&.Mui-focused': { color: '#da3831' }
                                    },
                                }}
                            />
                        </Grid>
                        {/* Nokta Ara */}
                        <Grid item xs={12} md={12} lg={2.5}>
                            <TextField
                                fullWidth
                                label="Şube Kodu Ara..."
                                value={filterBranchCode}
                                onChange={(e) => setFilterBranchCode(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    sx: { height: '52px' }
                                }}
                                sx={{
                                    '.MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#ccc' },
                                        '&:hover fieldset': { borderColor: '#da3831' },
                                        '&.Mui-focused fieldset': { borderColor: '#da3831' },
                                    },
                                    '.MuiInputLabel-root': {
                                        '&.Mui-focused': { color: '#da3831' }
                                    },
                                }}
                            />
                        </Grid>
                        {/* Bireysel/Kurumsal Seçimi */}
                        <Grid item xs={12} md={12} lg={2}>
                            <FormControl fullWidth sx={{ height: '52px' }}>
                                <InputLabel sx={{ '&.Mui-focused': { color: '#da3831' } }}>Bireysel/Kurumsal</InputLabel>
                                <Select
                                    value={filterType}
                                    label="Bireysel/Kurumsal"
                                    onChange={(e) => setFilterType(e.target.value)}
                                    sx={{
                                        'height': '100%',
                                        '.MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '.MuiSelect-select': { py: '8.5px' }
                                    }}
                                >
                                    <MenuItem value="all">Tümü</MenuItem>
                                    <MenuItem value="Bireysel">Bireysel</MenuItem>
                                    <MenuItem value="Kurumsal">Kurumsal</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* İl */}
                        <Grid item xs={12} md={12} lg={2}>
                            <FormControl fullWidth sx={{ height: '52px' }}>
                                <InputLabel sx={{ '&.Mui-focused': { color: '#da3831' } }}>İl</InputLabel>
                                <Select
                                    value={filterProvince}
                                    label="İl"
                                    onChange={(e) => setFilterProvince(e.target.value)}
                                    disabled={areLocationFiltersDisabled}
                                    sx={{
                                        'height': '100%',
                                        '.MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '.MuiSelect-select': { py: '8.5px' },
                                        '& .Mui-disabled': {
                                            opacity: 0.5,
                                            pointerEvents: 'none'
                                        }
                                    }}
                                >
                                    <MenuItem value="all">Tümü</MenuItem>
                                    {provinces.map(prov => <MenuItem key={prov} value={prov}>{prov}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* İlçe */}
                        <Grid item xs={12} md={12} lg={2}>
                            <FormControl fullWidth sx={{ height: '52px' }}>
                                <InputLabel sx={{ '&.Mui-focused': { color: '#da3831' } }}>İlçe</InputLabel>
                                <Select
                                    value={filterDistrict}
                                    label="İlçe"
                                    onChange={(e) => setFilterDistrict(e.target.value)}
                                    disabled={isDistrictDisabled}
                                    sx={{
                                        'height': '100%',
                                        '.MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#da3831' },
                                        '.MuiSelect-select': { py: '8.5px' },
                                        '& .Mui-disabled': {
                                            opacity: 0.5,
                                            pointerEvents: 'none'
                                        }
                                    }}
                                >
                                    <MenuItem value="all">Tümü</MenuItem>
                                    {districts.map(dist => <MenuItem key={dist} value={dist}>{dist}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Stack direction="row" spacing={1} sx={{ mt: 2, gap : 2 }} alignItems="center" flexWrap="wrap" justifyContent="space-between">
                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ 
                                flexGrow: 1
                            }}>
                            <Typography variant="body2" sx={{ color : 'rgba(154, 158, 166, 1)', minWidth: '80px' }}>Taglere Göre Filtrele:</Typography>
                            <Stack sx={{flexDirection : 'row', flexWrap : 'wrap', gap : 1,}}>
                                {availableTags.map((tag) => {
                                const tagStyle = getTagColorStyles(tag);
                                const isActive = activeTags.includes(tag);
                                return (
                                        <Chip
                                            key={tag}
                                            label={tag}
                                            clickable
                                            onClick={() => handleToggleTag(tag)}
                                            sx={{
                                                bgcolor: isActive ? tagStyle.color : tagStyle.bgcolor,
                                                color: isActive ? 'white' : tagStyle.color,
                                                fontWeight: 'bold',
                                                border: `1px solid ${isActive ? tagStyle.color : tagStyle.borderColor}`,
                                                fontSize: '14px',
                                                borderRadius : '5px',
                                                '&:hover': {
                                                    bgcolor: isActive ? tagStyle.color : tagStyle.bgcolor,
                                                    opacity: 0.9,
                                                },
                                            }}
                                        />
                                    );
                                })}
                            </Stack>
                        </Stack>
                        <Stack sx={{
                            flexDirection: { xs: 'column', sm: 'row' }, // Mobil ve küçük ekranlarda column, sm ve üzeri row
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: 2,
                            width: { xs: '100%', sm: 'auto' },                      
                        }}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    toast.info("Filtreler uygulandı.");
                                }}
                                sx={{ height: '44px', minWidth: '120px', bgcolor: '#da3831', '&:hover': { bgcolor: '#c02f2a' }, ml: 'auto', width: { xs: '100%', sm: 'auto' } }}
                            >
                                Filtrele
                            </Button>                            
                        </Stack>
                        <Stack sx={{width: '100%', flexDirection : {xs : 'column', lg: 'row'}, alignItems: 'center', justifyContent: 'space-between'}}>
                            {isPointSelection && (
                                    <Button
                                        variant="outlined"
                                        onClick={triggerFileInput}
                                        sx={{ height: '44px', bgcolor: '#da3831', minWidth: '120px', color: '#FFFFFF', borderColor: '#da3831', '&:hover': { borderColor: '#da3831', bgcolor: '#da3831' }, width: { xs: '100%', sm: 'auto' } }}
                                    >
                                        Excel'den Yükle
                                    </Button>
                                )}
                            <Stack sx={{flexDirection: {xs: 'column', lg: 'row'}, gap: 2, alignItems: 'center',}}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showOnlySelected}
                                                onChange={(e) => setShowOnlySelected(e.target.checked)}
                                                sx={{ color: '#da3831', '&.Mui-checked': { color: '#da3831' } }}
                                            />
                                        }
                                        label="Sadece Seçilenleri Göster"
                                        sx={{ m: 0 }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={handleClearAllSelections}
                                        sx={{ height: '44px', minWidth: '120px', borderColor: '#da3831', color: '#da3831', '&:hover': { borderColor: '#c02f2a', color: '#c02f2a', bgcolor: 'rgba(218, 56, 49, 0.05)' }, width: { xs: '100%', sm: 'auto' } }}
                                    >
                                        Seçimleri Temizle
                                    </Button>
                                </Stack>
                        </Stack>
                    </Stack>
                </Stack>
                {/* Pagination üstte */}
                <PaginationControls />
                {/* Liste Alanı */}
                <Box sx={{ flexGrow: 1, border: '1px solid #e0e0e0', borderRadius: 1, overflowY: 'auto', overflowX: 'auto' }}>
                    {/* Başlık Satırı */}
                    <Grid
                        container
                        sx={{
                            fontWeight: 'bold',
                            borderBottom: '1px solid #e0e0e0',
                            py: 1.5,
                            mb: 1,
                            bgcolor: 'rgba(255, 241, 243, 1)',
                            borderRadius: '4px',
                            // Responsive minWidth: Tüm sütunların toplam minimum genişliğine göre ayarlanmalı
                            minWidth: { xs: '900px', xl: 'auto' } // Örnek olarak 750px, içeriğe göre ayarlanmalı
                        }}
                    >
                        {/* Checkbox sütunu */}
                        <Grid item xs={0.5} sx={{ minWidth: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={areAllFilteredItemsSelected}
                                        onChange={handleSelectAllChange}
                                        sx={{ color: '#da3831', '&.Mui-checked': { color: '#da3831' } }}
                                    />
                                }
                                label=""
                                sx={{ m: 0 }}
                            />
                        </Grid>
                        {/* NOKTA ADI */}
                        <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', minWidth: '180px' }}>
                            <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>NOKTA ADI</Typography>
                        </Grid>
                        {/* KULLANICI ADI*/}
                        {!isPointSelection && (
                            <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', minWidth: '180px' }}>
                                <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>KULLANICI ADI</Typography>
                            </Grid>
                        )}
                        {/* APP KULLANIMI sadece kişi ekle ekranında */}
                        {!isPointSelection && (
                            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>APP</Typography>
                            </Grid>
                        )}
                        {/* TÜRÜ */}
                        <Grid item xs={1.5} sx={{ display: 'flex', alignItems: 'center', minWidth: '80px' }}>
                            <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>TÜRÜ</Typography>
                        </Grid>
                        {/* ŞUBE KODU */}
                        <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                            <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>ŞUBE KODU</Typography>
                        </Grid>
                        {/* TAGLERİ */}
                        <Grid item xs={1.5} sx={{ display: 'flex', alignItems: 'center', minWidth: '150px' }}>
                            <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>TAGLERİ</Typography>
                        </Grid>
                    </Grid>

                    {isLoading ? (
                        <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', mt: 4 }}>
                            Yükleniyor...
                        </Typography>
                    ) : pagedItems.length === 0 ? (
                        <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', mt: 4 }}>
                            Filtrelere uygun öğe bulunamadı.
                        </Typography>
                    ) : (
                        <FormGroup>
                            {pagedItems.map((item) => {
                                console.log("item : ",item)
                                // Tagler dinamik olarak point objesinin alanlarından oluşturulacak
                                const itemTags = [];
                                if (item.isTrendyol === '1') itemTags.push('Trendyol');
                                if (item.isHepsiburada === '1') itemTags.push('H.B');
                                if (item.isArasKargo === '1') itemTags.push('Aras Kargo');
                                if (item.isSuratkargo === '1') itemTags.push('Sürat Kargo');
                                if (item.kargoistID) itemTags.push('Kargoist');
                                if (item.hepsijetID) itemTags.push('Hepsijet');
                                return (
                                    <Grid
                                        container
                                        key={item.id}
                                        alignItems="center"
                                        sx={{
                                            borderBottom: '1px dotted #f0f0f0',
                                            py: 1,
                                            minWidth: { xs: '900px', xl: 'auto' },
                                            overflow : scroll,
                                        }}
                                    >
                                        {/* Checkbox sütunu */}
                                        <Grid item xs={0.5} sx={{ minWidth: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isPointSelection ? !!selectedPoints[item.id] : !!selectedPeople[item.id]}
                                                        onChange={isPointSelection ? (e) => handlePointCheckboxChange(item.id, e.target.checked) : (e) => handlePersonCheckboxChange(item.id, e.target.checked)}
                                                        sx={{ color: '#da3831', '&.Mui-checked': { color: '#da3831' } }}
                                                    />
                                                }
                                                label=""
                                                sx={{ m: 0 }}
                                            />
                                        </Grid>
                                        {/* Nokta Adı */}
                                        <Grid item xs={3} sx={{ minWidth: '180px' }}>
                                            {isPointSelection ? (
                                                <Typography variant="body2">{item.title}</Typography>
                                                ) : (
                                                <Typography variant="body2">{item.pointTitle}</Typography>
                                            )}                                     
                                        </Grid>
                                        {/* Username*/}
                                        {!isPointSelection && (
                                            <Grid item xs={3} sx={{ minWidth: '180px' }}>
                                                {(() => {
                                                    const matchedUser = users.find(u => u.id === item.id);
                                                    return (
                                                        <Typography variant="body2">{matchedUser ? matchedUser.username : '-'}</Typography>
                                                    );
                                                })()}
                                            </Grid>
                                        )}
                                        {/* App Kullanımı sadece kişi ekle ekranında */}
                                        {!isPointSelection && (
                                            <Grid item xs={1} sx={{ minWidth: '100px' }}>
                                                {(() => {
                                                    const matchedUser = users.find(u => u.id === item.id);
                                                    return (
                                                        <Typography variant="body2">{matchedUser ? (matchedUser.expoTokens ? 'Kullanıyor' : 'Kullanmıyor') : '-'}</Typography>
                                                    );
                                                })()}
                                            </Grid>
                                        )}
                                        {/* Türü */}
                                        <Grid item xs={1.5} sx={{ minWidth: '80px' }}>
                                            <Typography variant="body2">{item.isCorporational ? 'Kurumsal' : 'Bireysel' || '-'}</Typography>
                                        </Grid>
                                        {/* Şube Kodu */}
                                        <Grid item xs={1} sx={{ minWidth: '100px' }}>
                                            <Typography variant="body2">{item.branchCode || '-'}</Typography>
                                        </Grid>
                                        {/* Tagleri */}
                                        <Grid item xs={1.5} sx={{ minWidth: '150px' }}>
                                            <Stack
                                                direction="row"
                                                spacing={0.5}
                                                flexWrap="wrap"
                                                sx={{ maxHeight: '48px', overflow: 'hidden', gap: '2px' }}
                                            >
                                                {itemTags.length > 0 ? (
                                                    itemTags.map((tag, index) => {
                                                        const tagStyle = getTagColorStyles(tag);
                                                        return (
                                                            <Chip
                                                                key={`${item.id}-${tag}-${index}`}
                                                                label={tag}
                                                                size="small"
                                                                sx={{
                                                                    bgcolor: tagStyle.bgcolor,
                                                                    color: tagStyle.color,
                                                                    borderColor: tagStyle.borderColor,
                                                                    border: '1px solid',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '11px',
                                                                    height: 'auto',
                                                                    borderRadius : '5px',
                                                                    '& .MuiChip-label': {
                                                                        px: '6px',
                                                                        py: '2px',
                                                                    },
                                                                    whiteSpace: 'nowrap',
                                                                    flexShrink: 0,
                                                                }}
                                                            />
                                                        );
                                                    })
                                                ) : (
                                                    <Typography variant="body2" sx={{ color: '#888' }}>-</Typography>
                                                )}
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </FormGroup>
                    )}
                </Box>
                {/* Pagination altta */}
                <PaginationControls />
                <Box sx={{ position: 'fixed', bottom: 32, right: 32, zIndex: 9999 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleScrollToTop}
                        sx={{ minWidth: 0, borderRadius: '50%', p: 1.5, boxShadow: 3 }}
                    >
                        <KeyboardArrowUpIcon fontSize="large" />
                    </Button>
                </Box>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                        variant="contained"
                        onClick={handleSaveSelection}
                        sx={{ height: '44px', width: '100%', maxWidth : '146px', bgcolor: '#da3831', '&:hover': { bgcolor: '#c02f2a' } }}
                    >
                        Onayla
                    </Button>
                </Box>
            </Paper>
        );
    };

    // Onay Modalını render eden fonksiyon
    const renderConfirmModal = () => {
        // selectedPoints state'i zaten mevcut olduğu için doğrudan erişilebilir
        const selectedPointsCount = Object.keys(selectedPoints).filter(id => selectedPoints[id]).length;

        return (
            <Dialog
                open={isConfirmModalOpen}
                onClose={handleCloseConfirmModal}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',                        
                        width: '100%',                        
                        maxWidth: '429px',
                        padding: '30px',
                    }
                }}
            >
                <DialogTitle
                    id="confirm-dialog-title"
                    sx={{
                        bgcolor: 'transparent',
                        color: 'rgba(203, 72, 80, 1)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        p : 0,
                    }}
                >
                    Bildirim Gönderim Onayı
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseConfirmModal}
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                            p: 0.5,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ marginBlock: 2, p: 0, }}>
                    <DialogContentText
                        id="confirm-dialog-description"
                        sx={{
                            color: '#666',
                            fontSize: '14px',
                            lineHeight: 1.2,
                            textAlign: 'left',
                            color : 'rgba(71, 84, 103, 1)',
                        }}
                    >
                        Seçili <Box component="span" sx={{ fontWeight: 'bold' }}>{selectedPointsCount} noktadan</Box>,
                        seçili <Box component="span" sx={{ fontWeight: 'bold' }}>{totalSelectedPeopleCount} kullanıcıya</Box>  bildirim gönderilecektir, <Box component='span' sx={{fontWeight : 'bold'}}>onaylıyor musunuz?</Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{flexDirection: 'column', gap: 2, p: 0, }}>
                    <Button
                        onClick={() => {
                            handleSendNotification();
                            // handleSendNotification zaten modalı kapatıyor.
                        }}
                        sx={{
                            bgcolor: '#da3831',
                            color: 'white',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            py: 1.2,
                            width: '100%',
                            '&:hover': {
                                bgcolor: '#c02f2a',
                            }
                        }}
                        autoFocus
                    >
                        Gönderim İşlemini Onayla
                    </Button>
                    <Button
                        onClick={handleCloseConfirmModal}
                        variant="outlined"
                        sx={{
                            borderColor: '#da3831',
                            color: '#da3831',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            py: 1.2,
                            width: '100%',
                            ml : '0px !important',
                            '&:hover': {
                                borderColor: '#c02f2a',
                                color: '#c02f2a',
                                bgcolor: 'rgba(218, 56, 49, 0.05)'
                            }
                        }}
                    >
                        Vazgeç
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    return (
        <Box sx={{ px: {xs: 3}, pl: {md : 6}}}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', mb: 4, borderBottom: '1px solid #e0e0e0', pb: 2 }}>
                Bildirim Sistemi
            </Typography>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4, px: 0 }}>
                {currentStep === 1 && renderNotificationMessageScreen()}
                {currentStep === 2 && renderSelectionScreen(true)}
                {currentStep === 3 && renderSelectionScreen(false)}

                {renderConfirmModal()} {/* Onay modalı her zaman render edilebilir, open prop'u görünürlüğünü kontrol eder */}
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleExcelFileSelect}
                />
            </Container>
        </Box>
    );
};

export default NotificationManagement;